import { AHAUZ_PHONE_NUMBER } from "settings";

export const COPY_FORM_ERROR_CONTACT_SUPPORT = `Sorry, we can't update your details right now. Please try again or contact our Customer Support team on ${AHAUZ_PHONE_NUMBER}.`;
